import React, { useState, useEffect , useMemo} from 'react';
import { PlusCircle, Pencil, Ban, CheckCircle } from 'lucide-react';
import { useNavigate } from 'react-router-dom';

const TagList = () => {
  const [userList, setUsersList] = useState([]);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);
    const [searchTerm, setSearchTerm] = useState('');
    const [currentPage, setCurrentPage] = useState(1);
    const [itemsPerPage] = useState(10);
  const navigate = useNavigate();

  useEffect(() => {
    const fetchUserData = async () => {
      try {
        const userResponse = await fetch(`${process.env.REACT_APP_API_URL}/Mailer/GetAllTagsForAdmin`);

        if (!userResponse.ok) {
          throw new Error('Failed to fetch data');
        }

        const data = await userResponse.json();
        console.log("API Data:", data);

        if (data.response) {
          setUsersList(data.response);
        } else {
          setError('No tags available.');
        }
      } catch (error) {
        console.error('Error fetching data:', error);
        setError('Error fetching data.');
      } finally {
        setLoading(false);
      }
    };

    fetchUserData();
  }, []);

  const handleEditTag = (user) => {
    console.log('Tag data for editing:', user);
    navigate('/CreateTags', { state: { userData: user } });
  };

  const handleAddTag = () => {
    navigate('/CreateTags');
  };

  const handleBlockUser = async (tagValue, tagName, tagStatus) => {
    try {
      const body = {
        TagName: tagName,
        TagValue: tagValue,
        TagStatus: !tagStatus,
      };
  
      const response = await fetch(`${process.env.REACT_APP_API_URL}/Mailer/UpdateTags`, {
        method: 'POST',
        body: JSON.stringify(body),
        headers: {
          'Content-Type': 'application/json',
        },
      });
  
      if (!response.ok) {
        const errorText = await response.text();
        console.error('Error Response:', errorText);
        throw new Error('Failed to update tag status');
      }
  
      const updatedData = await response.json();
      console.log('Response from backend:', updatedData);
  
      // Update the local state immediately
      setUsersList(prevList => 
        prevList.map(tag => 
          tag.tagValue === tagValue 
            ? { ...tag, tagStatus: !tagStatus } 
            : tag
        )
      );
    } catch (error) {
      console.error('Error updating status:', error);
      alert('Failed to update status. Please try again later.');
    }
  };
// Filter and search functionality
    const filteredMails = useMemo(() => {
      const normalizedSearchTerm = searchTerm.toLowerCase();
  
      return userList.filter(user => {
       const matchesUser = user.tagName &&
    user.tagName.toLowerCase().includes(normalizedSearchTerm);
  
        
       // const matchesSender = user.fromEmail.toLowerCase().includes(normalizedSearchTerm);
      //  const matchesMailType = user.mailType.toLowerCase().includes(normalizedSearchTerm);
      //  const matchesDate = user.createdOn.toLowerCase().includes(normalizedSearchTerm);
        return matchesUser; //matchesSender || matchesMailType ||
      });
    }, [userList, searchTerm]);
  
    // Pagination
    const indexOfLastItem = currentPage * itemsPerPage;
    const indexOfFirstItem = indexOfLastItem - itemsPerPage;
    const currentItems = filteredMails.slice(indexOfFirstItem, indexOfLastItem);
  
    // Change page
    const paginate = (pageNumber) => setCurrentPage(pageNumber);
  
    const totalPages = Math.ceil(filteredMails.length / itemsPerPage);
  if (loading) {
    return <div>Loading...</div>;
  }

  if (error) {
    return <div>{error}</div>;
  }

   

  return (
    <div className="p-8">
      {/* Header */}
      <div className="flex justify-between items-center mb-6">
        <h1 className="text-2xl font-bold">TAG DETAILS</h1>
        <button
          className="bg-blue-500 hover:bg-blue-600 text-white px-4 py-2 rounded-lg flex items-center gap-2 transition-colors"
          onClick={handleAddTag}
        >
          <PlusCircle className="h-4 w-4" />
          Create Tag
        </button>
      </div>
  {/* Search Input */}
        <div className="p-4 bg-gray-100 border-b">
          <div className="max-w-md ml-auto relative">

            <input
              type="text"
              placeholder="Search..."
              className="w-full p-3 pl-10 text-gray-700 bg-white rounded-lg shadow-md focus:outline-none focus:ring-2 focus:ring-blue-500"
              value={searchTerm}
              onChange={(e) => {
                setSearchTerm(e.target.value);
                setCurrentPage(1); // Reset to first page when searching
              }}
            />
            <svg
              xmlns="http://www.w3.org/2000/svg"
              className="h-6 w-6 absolute left-3 top-3 text-gray-400"
              fill="none"
              viewBox="0 0 24 24"
              stroke="currentColor"
            >
              <path
                strokeLinecap="round"
                strokeLinejoin="round"
                strokeWidth={2}
                d="M21 21l-6-6m2-5a7 7 0 11-14 0 7 7 0 0114 0z"
              />
            </svg>
          </div>
        </div>
      {/* Table */}
      <div className="w-full overflow-x-auto bg-white rounded-lg shadow">
        <table className="w-full">
          <thead className="bg-gradient-to-r from-blue-500 to-purple-600">
            <tr>
              <th className="px-6 py-3 text-left text-sm font-semibold text-white">Tag Name</th>
              <th className="px-6 py-3 text-left text-sm font-semibold text-white">Status</th>
              <th className="px-6 py-3 text-left text-sm font-semibold text-white">Actions</th>
              <th className="px-6 py-3 text-left text-sm font-semibold text-gray-600 hidden">Tag Id</th>
            </tr>
          </thead>
          <tbody className="divide-y divide-gray-200">
              {currentItems.length > 0 ? (
                currentItems.map((user, index) => (
           // {userList.length > 0 ? (
             // userList.map((user, index) => (
                <tr key={index} className="hover:bg-gray-50">
                  <td className="px-6 py-4 text-sm text-gray-900">{user.tagName}</td>
                  <td className="px-6 py-4 text-sm text-gray-900">
                    {user.tagStatus ? 'Active' : 'Inactive'}
                  </td>
                  <td className="px-6 py-4">
                    <div className="flex gap-2">
                      {/* <button
                        className="p-1 hover:bg-gray-100 rounded-lg transition-colors"
                        onClick={() => handleEditTag(user)}
                      >
                        <Pencil className="h-4 w-4 text-gray-600" />
                      </button> */}
                      <button
                        className="p-1 hover:bg-gray-100 rounded-lg transition-colors"
                        onClick={() => handleBlockUser(user.tagValue, user.tagName, user.tagStatus)}
                      >
                        {user.tagStatus ? (
                          <Ban className="h-4 w-4 text-gray-600" />
                        ) : (
                          <CheckCircle className="h-4 w-4 text-green-600" />
                        )}
                      </button>
                    </div>
                  </td>
                  <td className="px-6 py-4 text-sm text-gray-900 hidden">{user.tagValue}</td>
                </tr>
              ))
            ) : (
              <tr>
                <td colSpan="4" className="px-6 py-4 text-sm text-center text-gray-600">No Tags found</td>
              </tr>
            )}
          </tbody>
        </table>
          {/* Pagination */}
        {totalPages > 1 && (
          <div className="bg-gray-100 px-4 py-3 flex items-center justify-center space-x-2">
            <button
              onClick={() => paginate(currentPage - 1)}
              disabled={currentPage === 1}
              className="px-4 py-2 text-sm font-medium text-gray-700 bg-white rounded-lg border border-gray-300 hover:bg-gray-50 disabled:opacity-50 disabled:cursor-not-allowed"
            >
              Previous
            </button>

            {[...Array(totalPages)].map((_, index) => (
              <button
                key={index}
                onClick={() => paginate(index + 1)}
                className={`px-4 py-2 text-sm font-medium rounded-lg border 
                  ${currentPage === index + 1
                    ? 'bg-blue-500 text-white border-blue-500'
                    : 'bg-white text-gray-700 border-gray-300 hover:bg-gray-50'
                  }`}
              >
                {index + 1}
              </button>
            ))}

            <button
              onClick={() => paginate(currentPage + 1)}
              disabled={currentPage === totalPages}
              className="px-4 py-2 text-sm font-medium text-gray-700 bg-white rounded-lg border border-gray-300 hover:bg-gray-50 disabled:opacity-50 disabled:cursor-not-allowed"
            >
              Next
            </button>
          </div>
        )}
      </div>
    </div>
  );
};

export default TagList;  